import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ShopContext } from '../../context/shopContext';
import cross from '../assets/x-solid.svg';
import unfav from '../assets/heart.svg';
import fav from '../assets/heart-solid.svg';
import './cardModal.css';

const Modal = (props) => {
    const { isFavourite, addToFavourites, removeFromFavourites } = useContext(ShopContext);
    const { closeContactModal } = props;

    const handleFavoriteClick = () => {
        if (isFavourite(props.id)) {
            removeFromFavourites(props.id);
        } else {
            addToFavourites(props.id);
        }
    };

    const handleCloseModal = () => {
        closeContactModal(false); 
    };



    return (
        <div className="card-modal-background">
            <div className="card-modal-cancel-background" onClick={handleCloseModal}></div>
            <div className="card-modal-container">
                <img className="exit-btn" onClick={handleCloseModal} src={cross} alt="Close" />
                <div className="card-modal-title">
                    <img className="card-modal-product-image" src={props.image} alt="Product" />
                </div>
                <div className="card-modal-btn-container">
                    <Link to={`/card/${props.id}`}>
                        <button className="modal-cc-btn" onClick={handleCloseModal}>Choose Card</button>
                    </Link>
                    {isFavourite(props.id) ? (
                        <div onClick={handleFavoriteClick} className="card-modal-heart-cont">
                            <img className="card-modal-heart" src={fav} alt="Favorited" />
                        </div>
                    ) : (
                        <div onClick={handleFavoriteClick} className="card-modal-heart-cont">
                            <img className="card-modal-heart" src={unfav} alt="Not Favorited" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Modal;
